/**
 * Top offset (px) of the current-progress bubble: the top of a
 * checkpoint-sized box on a track whose nodes sit `step` px apart.
 *
 * The bubble's position expresses only "which segment you are in", no longer
 * "how far through the segment" — the number inside the bubble is the only
 * progress truth. Every segment unconditionally renders the bubble at its
 * fixed midpoint, so jump point pills (anchored to checkpoints) never cover
 * it.
 *
 * Boundaries:
 * - score exactly at checkpoint A falls in [A, B): the bubble sits at that
 *   segment's midpoint while A's node shows done
 * - score at or past the last checkpoint clamps to the last node
 */
export function getProgressBubbleTop(
  score: number,
  checkpoints: number[],
  step: number,
): number {
  const idx = checkpoints.findIndex((cp) => cp > score)
  if (idx === -1) return (checkpoints.length - 1) * step
  // Segment [checkpoints[idx - 1], checkpoints[idx]) contains the score;
  // scores below the first checkpoint (unreachable — checkpoints start at 0)
  // collapse into the first segment.
  const segment = Math.max(idx - 1, 0)
  return (segment + 0.5) * step
}
